import { render, staticRenderFns } from "./Payslip.vue?vue&type=template&id=74c3c890&scoped=true&"
import script from "./Payslip.vue?vue&type=script&lang=js&"
export * from "./Payslip.vue?vue&type=script&lang=js&"
import style0 from "./Payslip.vue?vue&type=style&index=0&id=74c3c890&scoped=true&lang=css&"
import style1 from "./Payslip.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c3c890",
  null
  
)

export default component.exports